import { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { TaskDto } from "../../entities/processCycle/TaskDto";
import { AppDispatch, AppState } from "../../store/configureStore";
import { confirmTasksDataByWorkerId, getActiveTasksForWorker } from "../../store/slices/candidateProcesses";
import PersonalInfoCard from "../Dashboards/Employee/Cards/PersonalInfoCard";
import BasePage from "../UI/BasePage";
import SimpleCard from "../UI/SimpleCard";
import "./CandidateDashboardPage.css";
import ContractSigningCard from "./ContractSigningCard";
import JobOfferCard from "./JobOfferCard";

const CandidateDashboardPage = () => {
    const { t } = useTranslation("candidate_portal");
    const dispatch = useDispatch<AppDispatch>();

    const { list: candidateTasks, reloadTrigger } = useSelector(
        (state: AppState) => state.entities.candidateTasks
    );

    useEffect(() => {
        dispatch(getActiveTasksForWorker());
    }, [dispatch, reloadTrigger]);

  

    const TASK_TYPE_WORKFLOW = 0;
    const TASK_TYPE_SIGNING = 2;
    const CANDIDATE_STATUS_AGREED = 3;
    const TASK_STATUS_COMPLETED = 1;
    const TASK_STATUS_OPEN = 0;

    const IsInteractive = (task: TaskDto) => {
        return task.Status === TASK_STATUS_OPEN && (task.Type === TASK_TYPE_SIGNING || task.CandidateTaskStatusId !== CANDIDATE_STATUS_AGREED)
    }

    const activeTasks = [...candidateTasks].sort((a: TaskDto, b: TaskDto) => {
        const createdA = a.Created ? new Date(a.Created).getTime() : 0;
        const createdB = b.Created ? new Date(b.Created).getTime() : 0;
        return createdB - createdA;
    });

    const workflowTasks = activeTasks.filter(t => t.Type === TASK_TYPE_WORKFLOW);

    const leftTasks = activeTasks
        .filter((task: TaskDto) =>
            task.Type === TASK_TYPE_WORKFLOW || task.Type === TASK_TYPE_SIGNING
        )
        .sort((a: TaskDto, b: TaskDto) => {

            if (IsInteractive(a) && !IsInteractive(b)) {
                return -1; // a comes first
            }
            if (IsInteractive(b) && !IsInteractive(a)) {
                return 1; // b comes first
            }

            const createdA = a.Modified ? new Date(a.Modified).getTime() : 0;
            const createdB = b.Modified ? new Date(b.Modified).getTime() : 0;
            return createdB - createdA;
        });

    const onPersonalDataSubmited = () => {
        dispatch(confirmTasksDataByWorkerId());
    };

    const isNewTaskPresent = workflowTasks.some(x => x.Status === TASK_STATUS_OPEN && x.CandidateTaskStatusId === CANDIDATE_STATUS_AGREED);

    return (
        <BasePage className="page-candidate-dashboard">
            <Row>
                <div className={(activeTasks.length > 1) ? "col" : ""}>
                    <Row>
                        {leftTasks.map((task: TaskDto) => (
                            <Col key={`job-offer-${task.Id}`}>
                                <SimpleCard
                                    className={`${IsInteractive(task)
                                        ? "card-alert"
                                        : ""
                                        } ${task.Type === TASK_TYPE_WORKFLOW ? "jobOfferCard" : "contractSigningCard"}`}
                                    key={task.Id}
                                    title={task.Type === TASK_TYPE_WORKFLOW ? t("jobOffer.title") : t("contract.title")}
                                >
                                    {task.Type === TASK_TYPE_WORKFLOW ? (
                                        <JobOfferCard
                                            task={task}
                                        />
                                    ) : (
                                        <ContractSigningCard
                                            task={task}
                                        />
                                    )}
                                </SimpleCard>
                            </Col>
                        ))}
                    </Row>
                </div>
                {workflowTasks.some(x => x.Type === TASK_TYPE_WORKFLOW && x.CandidateTaskStatusId === CANDIDATE_STATUS_AGREED) ? (
                    <Col xs={12} lg={6}>
                        <SimpleCard
                            className={`${isNewTaskPresent ? "card-alert" : ""}`}
                            title={isNewTaskPresent ? t("personalInfo.plzFill") : t("pages:profile.cards.personalInfo")}
                        >
                            <PersonalInfoCard
                                isInEditMode={isNewTaskPresent}
                                onSubmit={() => onPersonalDataSubmited()}
                            />
                        </SimpleCard>
                    </Col>
                ) : null}
            </Row>
        </BasePage>
    );
};

export default CandidateDashboardPage;